import { UserLayout } from "../UserLayout";
import {
  CalendarActivityDetailSection,
  CalendarActivityHeaderSection,
} from "../../../modules";

export const CalendarActivity = () => {
  return (
    <UserLayout>
      <CalendarActivityHeaderSection />
      <CalendarActivityDetailSection />
    </UserLayout>
  );
};
